<template>
    <div>
        <ChartManager ref="chart"
                      :height="height"
                      :width="width"
                      chart-type="timeseries"
                      :distribution="distribution"
                      :stacked="true"
                      v-bind:processedData="processedData"
                      :is_render_ready="true"
        />
    </div>
</template>

<script>
    export default {
        props: ['height','width','processedData','distribution']
    }
</script>